import { FC } from 'react';
import { InputNumber } from 'antd';

import FontFamilyDropdown from '@/shared/components/dropdowns/FontFamilyDropdown';

import { editableTokenKeys, ThemeTokenKey, toTokenString } from '../../configuration';
import WhitelabelColorInput from '../WhitelabelColorInput';

interface WhitelabelThemeTokenInputProps {
    field: (typeof editableTokenKeys)[number];
    onChange: (key: ThemeTokenKey, value: string | number | undefined) => void;
    value: string | number | undefined;
}

const WhitelabelThemeTokenInput: FC<WhitelabelThemeTokenInputProps> = ({ field, onChange, value }): JSX.Element => {
    if (field.type === 'number') {
        return (
            <InputNumber
                min={0}
                max={48}
                value={typeof value === 'number' ? value : 4}
                onChange={(nextValue) => onChange(field.key, nextValue ?? 0)}
                style={{ width: '100%' }}
            />
        );
    }

    if (field.type === 'font') {
        return (
            <FontFamilyDropdown value={toTokenString(value)} onChange={(nextValue) => onChange(field.key, nextValue)} />
        );
    }

    const colorValue = toTokenString(value, '#000000');

    return <WhitelabelColorInput value={colorValue} onChange={(nextValue) => onChange(field.key, nextValue)} />;
};

export default WhitelabelThemeTokenInput;
